import { render } from "./ProfileCardSkeleton.vue?vue&type=template&id=7dabd308&scoped=true"
const script = {}

import "./ProfileCardSkeleton.vue?vue&type=style&index=0&id=7dabd308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dabd308"]])

export default __exports__